export default "__VITE_ASSET___agBUU25__"